import Vue from 'vue'

export const exclusiveConfirmState = Vue.observable({ key: '' })

export const exclusiveConfirmMixin = {
  computed: {
    exclusiveConfirmKey() {
      return exclusiveConfirmState.key
    },
  },
  methods: {
    onExclusiveConfirmInput(key, visible) {
      if (visible) {
        exclusiveConfirmState.key = key
        return
      }
      if (exclusiveConfirmState.key === key) {
        exclusiveConfirmState.key = ''
      }
    },
    closeExclusiveConfirm(key) {
      if (!key || exclusiveConfirmState.key === key) {
        exclusiveConfirmState.key = ''
      }
    },
  },
}
